<template>
  <div>
    <h1 class="page-title" data-testid="page-title">Integrations</h1>
    <p class="page-description">
      Zight provides seamless integration options to supercharge your workflow automation. From embedding Zight links anywhere to leveraging webhooks that
      notify your tools about new items or activity, we've got you covered. Plus, Zight offers full integrations with popular platforms like Zendesk, Jira,
      Microsoft Teams and Slack, making collaboration effortless.
    </p>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped>
.page-title {
  @apply text-3xl font-bold mb-4;
}

.page-description {
  @apply text-base leading-6 mb-4;
}
</style>
